import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

function SessionExpiredDialog({ open, onRelogin, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="session-expired-dialog-title"
      aria-describedby="session-expired-dialog-body"
    >
      <DialogTitle id="session-expired-dialog-title">
        {"세션이 만료됨"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="session-expired-dialog-body">
          세션이 만료되어 로그아웃 되었습니다. 다시 로그인 하시겠습니까?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          아니오
        </Button>
        <Button onClick={onRelogin} color="primary" autoFocus>
          네
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionExpiredDialog;
